import script from "./ExpiredProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpiredProductList.vue?vue&type=script&setup=true&lang=js"

import "./ExpiredProductList.vue?vue&type=style&index=0&id=64224916&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64224916"]])

export default __exports__